<template>
  <v-container class="stockli__login-container gray-bkgr">
    <v-row class="mt-6">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3" class="mx-auto">
        <v-form ref="form" @submit.prevent="Submit">
          <v-card class="stockli__login-form">
            <div class="h3 tac pa-6 uppercase bold">Reset Password</div>
            <div v-if="!complete">
              <v-card-text>
                <p class="mb-8">Reset the password for {{ email }} by entering a new password below.</p>
                <v-text-field v-model="password" prepend-icon="mdi-lock" label="Password" type="password" autocomplete="new-password" :rules="[ruleRequired]" />
                <v-text-field
                  v-model="passwordConfirm"
                  prepend-icon="mdi-lock-check"
                  label="Confirm Password"
                  type="password"
                  autocomplete="new-password"
                  :rules="[ruleRequired, ruleConfirm]"
                />
                <v-alert type="error" v-if="submitError">{{ submitError }}</v-alert>
              </v-card-text>
              <v-card-actions class="justify-center pb-8">
                <v-btn type="submit" :loading="submitting" :disabled="submitting" class="btn">Reset Password</v-btn>
              </v-card-actions>
            </div>
            <div v-else>
              <v-card-text>
                <p>The password for {{ email }} has been reset.</p>
                <p>You may now login using the new credentials.</p>
              </v-card-text>
              <v-card-actions class="justify-center pb-8">
                <v-btn to="/login" class="btn">Return to login</v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import API from "@/services/api";

export default {
  name: "Reset",
  components: {
  },
  data: () => ({
    password: "",
    passwordConfirm: "",

    email: "",
    code: "",

    submitting: false,
    submitError: null,
    complete: false,

    ruleRequired: v => !!v || "This field is required",
  }),
  computed: {
    ruleConfirm() {
      return v => v === this.password || "Passwords must match";
    },
  },
  mounted() {
    this.email = this.$route.query.email;
    this.code = this.$route.query.code;
  },
  methods: {
    async Submit() {
      if (!this.$refs.form.validate()) return;

      this.submitting = true;
      this.submitError = null;
      try {
        await API.Reset(this.email, this.code, this.password);
        this.complete = true;
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          this.submitError = err.response.data.message;
        } else {
          this.submitError = "Unable to reset your password";
        }
      } finally {
        this.submitting = false;
      }
    },
  }
}
</script>
<style scoped lang="scss">
.stockli__login-container {
  height: 100vh;
}

.stockli__login-form {
  width: 80%;
  max-width: 400px;
  margin: auto;
  box-shadow: none;
}
</style>
